<div *ngIf="!mobile && show"
  class="block overflow-hidden border_customize_card border-2 z-50 my-4 max-w-sm text-base list-none card_color rounded-lg shadow-lg"
  style="position: absolute; right: 10px; top: 60px;" data-popper-placement="bottom">
  <div class="block py-2 px-4 text-lg font-medium text-left text_white">
    Cajero
  </div>
  <div>
    <div class="text_white px-4 rounded-lg shadow-md gap-6">
      <div class="space-y-2">
        <div *ngFor="let transaction of transactions" class="button_color shadow-lg shadow-gray-200 rounded-lg p-2">
          <!-- Listado de elementos (como "Bonos") -->
          <dl class="grid grid-cols-2 gap-12 sm:grid-cols-2">
            <!-- Elemento 1 -->
            <div class="flex items-center space-x-2">
              <dd class="text-sm font-semibold text_gray flex items-center gap-2">

                <span class="text_blue card_color px-2 py-1 rounded-full text-xl">
                  <ng-container *ngIf="transaction.type === 'Retiro'; else compraTemplate">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text_red icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-up">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                      <path d="M12 8l-4 4" />
                      <path d="M12 8v8" />
                      <path d="M16 12l-4 -4" />
                    </svg>
                  </ng-container>
                  <ng-template #compraTemplate>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text_green icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-down">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                      <path d="M8 12l4 4" />
                      <path d="M12 8v8" />
                      <path d="M16 12l-4 4" />
                    </svg>
                  </ng-template>


                </span>
                <span class="font-medium text_white">
                  {{ transaction.type }}
                  <p class="text-sm font-normal">{{ transaction.createdAt | date : "dd-MM-yyyy" }}</p>
                </span>
              </dd>
            </div>

            <!-- Elemento 2 -->
            <div class="flex items-center space-x-2">
              <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                <span class="text_yellow text-xl gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                    <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                    <path d="M12 3v4" />
                    <path d="M12 17v4" />
                    <path d="M3 12h4" />
                    <path d="M17 12h4" />
                    <path d="M18.364 5.636l-2.828 2.828" />
                    <path d="M8.464 15.536l-2.828 2.828" />
                    <path d="M5.636 5.636l2.828 2.828" />
                    <path d="M15.536 15.536l2.828 2.828" />
                  </svg>
                </span>
                <span class="font-medium text_white">{{ transaction.creditsAmount | number }}</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
    <!-- Más elementos de notificación aquí -->
  </div>
  <a (click)="redirectToTransactions()"
    class="transition-all duration-200 mx-4 my-2 block py-2 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg">
    <div class="inline-flex items-center">
      Ver más
    </div>
  </a>
</div>
<div *ngIf="mobile && show" class="card_color rounded-xl my-2 w-full py-6 px-4 text_white">
  <h2 class="text-md font-semibold mb-4 text-left ml-1">Cajero</h2>

  <div class="text_white rounded-lg shadow-md gap-6">
    <div class="space-y-2">
      <div *ngFor="let transaction of transactions" class="button_color_m shadow-lg shadow-gray-200 rounded-lg p-2">
        <!-- Listado de elementos (como "Bonos") -->
        <dl class="grid grid-cols-2 gap-12 sm:grid-cols-2">
          <!-- Elemento 1 -->
          <div class="flex items-center space-x-2">
            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
              <span class="text_blue card_color px-2 py-1 rounded-full text-xl">
                <ng-container *ngIf="transaction.type === 'Retiro'; else compraTemplate">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text_red icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-up">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                    <path d="M12 8l-4 4" />
                    <path d="M12 8v8" />
                    <path d="M16 12l-4 -4" />
                  </svg>
                </ng-container>
                <ng-template #compraTemplate>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text_green icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-down">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                    <path d="M8 12l4 4" />
                    <path d="M12 8v8" />
                    <path d="M16 12l-4 4" />
                  </svg>
                </ng-template>

              </span>
              <span class="font-medium text_white">
                {{ transaction.type }}
                <p class="text-sm font-normal">{{ transaction.createdAt | date : "dd-MM-yyyy" }}</p>
              </span>
            </dd>
          </div>

          <!-- Elemento 2 -->
          <div class="flex items-center space-x-2">
            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
              <span class="text_yellow text-xl gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                  <path d="M12 3v4" />
                  <path d="M12 17v4" />
                  <path d="M3 12h4" />
                  <path d="M17 12h4" />
                  <path d="M18.364 5.636l-2.828 2.828" />
                  <path d="M8.464 15.536l-2.828 2.828" />
                  <path d="M5.636 5.636l2.828 2.828" />
                  <path d="M15.536 15.536l2.828 2.828" />
                </svg>
              </span>
              <span class="font-medium text_white">{{ transaction.creditsAmount | number }}</span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>

  <a (click)="redirectToTransactions()"
    class="transition-all duration-200 mx-4 my-2 block py-2 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg">
    <div class="inline-flex items-center">
      Ver más
    </div>
  </a>
</div>